import utilTool from '../utils/util-tool';
import { h } from 'vue';
const crypto = require('crypto-js');

// AM-465167,AM-480688
const getHashClass = (content) => {
    return `lofty_${crypto.SHA256(content).toString()}`;
}


function attributesToObject(scriptTag) {
    const attributes = {};

    const regex = /([a-zA-Z0-9-_]+)(?:=["']([^"']*)["'])?/g;
    let match;

    // 遍历所有匹配的属性
    while ((match = regex.exec(scriptTag)) !== null) {
        const attributeName = match[1];
        const attributeValue = match[2] !== undefined ? match[2] : true; 
        attributes[attributeName] = attributeValue;
    }

    //console.log(attributes);
    return attributes;
}

//  analyze html in the string script tag and add to body middle
function runScript(list, container) {
    var psScripts = Promise.resolve();
   
    list.forEach(m => {
        var s = m.match(/^\<script([^>]*)\>([\s\S]*)\<\\\/script\>$/);
        if (s) {
            let positionEle;
            if (container && container.querySelector) {
                positionEle = container.querySelector(`.${getHashClass(m)}`);
            }

            // console.log(s);
            // <script> The case where there is code inside
            let innerCode = '';
            let attrObj = {};
            if (s[2] && /\w/.test(s[2])) {
                innerCode = s[2];
            }
            // <script> When tags have attributes ( Usually external links )
            if (s[1]) {
                attrObj = attributesToObject(s[1] || '');
                // console.log("=====attrObj=", attrObj, innerCode);
            }
            if (attrObj.type == 'application/ld+json') {
                console.log("=====attrObj===ld+json", attrObj);
                return psScripts;
            }
            const script = document.createElement('script');
            for (let name in attrObj) {
                if (attrObj.hasOwnProperty(name)) {
                    script.setAttribute(
                        name,
                        attrObj[name]
                    );
                }
            }
            if (innerCode) {
                script.innerHTML = innerCode;
            }

            if (attrObj.src) {
                script.async = true;
                script.src = attrObj.src;
                psScripts = psScripts.then(() => {
                    let ps = new Promise((resolve) => {
                        if (script.readyState) {
                            //IE
                            script.onreadystatechange = function() {
                                if (
                                    script.readyState === 'loaded' ||
                                    script.readyState === 'complete'
                                ) {
                                    script.onreadystatechange = null;
                                    resolve();
                                }
                            };
                        } else {
                            //Others
                            script.onload = function() {
                                resolve();
                            };
                        }
                    });
                    if (positionEle) {
                        positionEle.replaceWith(script);
                    } else {
                        document.body.appendChild(script);
                    }
                    return ps;
                });
            } else if (innerCode) {
                psScripts = psScripts.then(() => {
                    if (positionEle) {
                        positionEle.replaceWith(script);
                    } else {
                        document.body.appendChild(script);
                    }
                });
            }
        }
    });
    return psScripts;
}


// replace SSR  v-html  ， resolve https://github.com/vuejs/core/issues/8112
export const renderHtml = {
    props: {
        tag: {
            type: String,
            default: 'div'
        },
        innerHTML: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        class: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            caches: ''
        };
    },
    computed: {
        pureHtml({ innerHTML }) {
            if (!innerHTML) {
                return '';
            }
            return trimScript(innerHTML);
        }
    },
    mounted() {
        this.runScript();
    },
    updated() {
        this.runScript();
    },
    methods: {
        async runScript() {
            if (
                utilTool.isSSRServer ||
                !this.innerHTML ||
                this.caches == this.innerHTML
            ) {
                return;
            }
            this.caches = this.innerHTML;
            let cache = this.innerHTML;
            await utilTool.sleep();
            if (cache != this.innerHTML) {
                return;
            }
            const reg = /\<script[^>]*\>[\s\S]*?\<\\\/script\>/g;
            //  analyze <script><\/script>,  Manual conversion to script loading
            var mlist = this.innerHTML.match(reg);
            if (mlist) {
                runScript(mlist, this.$el);
            }
        }
    },
    render() {
        // console.log(this.pureHtml)
        return h(this.tag, {
            innerHTML: this.pureHtml,
            class: this.class,
            id: this.id
        });
    }
};

const encodeScript = (code = '') => {
    return code.replace(/<\/script>/g, '<\\/script>');
};

const decodeScript = code => {
    code = code || '';
    return code.replace(/<\\\/script>/g, '\x3C/script>');
};

const trimScript = (code = '') => {
    code = encodeScript(code);
    return code.replace(/\<script[^>]*\>[\s\S]*?\<\\\/script\>/g, (m) => {
        var s = m.match(/^\<script([^>]*)\>([\s\S]*)\<\\\/script\>$/);
        if (s && s[1]) {
            let attrObj = attributesToObject(s[1] || '');
            if (attrObj.type == 'application/ld+json') {
                return decodeScript(m);
            }
        }
        return `<span class="${getHashClass(m)}"></span>`;
    });
};

export const getButtonHtmlStyle = button => {
    if (!button.text && button?.textOption?.style) {
        return button.textOption.style;
    }
    let styleContent = button.text || button.html;
    return getHtmlStyle(styleContent);
};

export const getHtmlStyle = styleContent => {
    if (!styleContent) {
        return {}
    }
    let style = {};
    if (styleContent.includes('<em>')) {
        style['font-style'] = 'italic';
    }
    var styleTags = styleContent.match(/(?:style\s*?=\s*?(['"])([\s\S]*?)\1)/g);
    if (styleTags) {
        for (let i = 0; i < styleTags.length; i++) {
            let styleText = styleTags[i]
                .match(/(['"])(([\s\S]*?))\1/g)[0]
                .replace(/('|")/g, '');
            let styleItems = styleText.split(';');
            for (let j = 0; j < styleItems.length; j++) {
                var stylekv = styleItems[j].split(':');
                if (stylekv[0] && stylekv[0].trim()) {
                    let key = stylekv[0].trim();
                    let value = stylekv[1].trim();
                    style[key] = value;
                }
            }
        }
    }
    return style;
};
